/* import __COLOCATED_TEMPLATE__ from './appointments-feature-details.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { inject as service } from '@ember/service';
import { equal, not } from '@ember/object/computed';
import Component from '@glimmer/component';
let AppointmentsFeatureDetailsComponent = (_dec = equal('planFreeTrialDaysLeft', 0), _dec2 = not('shouldSubscribe'), _class = class AppointmentsFeatureDetailsComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "appointmentsFeatureInfo", _descriptor, this);
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor2, this);
    _initializerDefineProperty(this, "formatter", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "shouldSubscribe", _descriptor5, this);
    _initializerDefineProperty(this, "canHaveFreeTrial", _descriptor6, this);
  }
  get currencyCode() {
    return this.args.currencyCode ?? 'USD';
  }
  get featureDescription() {
    if (this.featureId) {
      return this.appointmentsFeatureInfo.getFeatureDetailedDescription(this.featureId);
    }
    return '';
  }
  get featureId() {
    return this.args.featureId;
  }
  get featureTitle() {
    if (this.featureId) {
      return this.appointmentsFeatureInfo.getFeatureTitle(this.featureId);
    }
    return '';
  }
  get formattedPlanPrice() {
    return this.formatter.currency(this.planPriceInCent, this.currencyCode, {
      maximumFractionDigits: 0 // no decimal places in subscription price
    });
  }
  get freeTrialDescription() {
    return this.intl.t('apptsUpsell.subscription.freeTrial.description', {
      freeTrialDaysLeft: this.planFreeTrialDaysLeft,
      planName: this.planName,
      planPrice: this.formattedPlanPrice
    });
  }
  get planFreeTrialDaysLeft() {
    return this.args.planFreeTrialDaysLeft ?? 0;
  }
  get planName() {
    return this.args.planName ?? '';
  }
  get planPriceInCent() {
    return this.args.planPriceInCent ?? 0;
  }
  get planTitle() {
    return this.intl.t('apptsUpsell.square.appointments.plan', {
      planName: this.planName
    });
  }
  get subscribeButtonLabel() {
    return this.shouldSubscribe ? this.intl.t('apptsUpsell.common.subscribeTo', {
      planName: this.planName
    }) : this.intl.t('apptsUpsell.common.tryFree', {
      planName: this.planName
    });
  }
  get imageClass() {
    if (this.featureId) {
      return `appointments-feature-details__image appointments-feature-details__image--${this.appointmentsFeatureInfo.getFeatureDetailsImageName(this.featureId)}`;
    }
    return '';
  }

  // TODO - remove this check after images have been localized (https://square.slack.com/archives/C031G6E6ATX/p1666196114375429)
  get isImageVisible() {
    const allowedLocale = ['en-us', 'en'].includes(this.intl.primaryLocale.toLowerCase());
    const allowedCountry = this.appointmentsSubscription.countryCode === 'US';
    return allowedLocale && allowedCountry;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "appointmentsFeatureInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "shouldSubscribe", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "canHaveFreeTrial", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { AppointmentsFeatureDetailsComponent as default };